// extracted by mini-css-extract-plugin
export default {"section":"LoadingSection_section__dZho7","spinner":"LoadingSection_spinner__WSxBi"};